
const FormValidationRules = {
  inputSloGsmValidation (rule, value, callback) {
    let re = new RegExp('(?:0|386)(?:65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6})$')
    if (!re.test(value)) {
      callback(new Error('GSM ni v pravilnem formatu'))
    } else {
      callback()
    }
  },
  inputNotEmptyValidation (rule, value, callback) {
    if (value === '' || value === null || value === undefined) {
      callback(new Error('Polje ne sme biti prazno'))
    } else {
      callback()
    }
  },
  inputEmailValidation (rule, value, callback) {
    let re = new RegExp([
      '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.',
      '[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
    ].join(''))
    if (!re.test(value)) {
      callback(new Error('Email ni v pravilnem formatu'))
    } else {
      callback()
    }
  }
}

export default {
  install (Vue, options) {
    Vue.prototype.formValidation = FormValidationRules
  }
}




// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormValidationRules.js